import React, { memo, useMemo } from 'react';
import { IDataGridMadel, IDataGridRowProps } from '../model';
import { GridCard, resolveCardLayout } from './card';

interface Props {
  model: IDataGridMadel;
  /** Undefined while the first request is in flight (the table path defaults it the same way). */
  data?: any[];
  rowControls?: any;
  rowProps?: IDataGridRowProps;
}

/**
 * The card list a grid renders below `md` (Phase F1, D-10 / D-53; since N2b /
 * PD-10 every grid, unless its config opted out). It replaces `Table` only:
 * toolbar, filters, pagination, loading, empty and delete states stay the
 * grid's own. The table head is
 * gone, so sorting is kept reachable by the toolbar's sort button
 * (`CardSortButton`, N2 / T2), which dispatches the same tasks the sort row
 * above this list did (PD-09 / N1; DC-16 reversed). Row swap (drag) is
 * table-only.
 */
export const CardList = memo<Props>(({ model, data = [], rowControls, rowProps }) => {
  // N2c (T4): the automatic title reads the rows' values (never an id, a number or a date)
  const layout = useMemo(() => resolveCardLayout(model, data), [model, data]);
  return (
    <div className="data-grid-cards">
      <div className="data-grid-cards__list">
        {data.map((item) => {
          const key = item[model.store.mainField];
          return (
            <GridCard
              key={key}
              uKey={key}
              item={item}
              model={model}
              layout={layout}
              rowControls={rowControls}
              rowProps={rowProps}
            />
          );
        })}
      </div>
    </div>
  );
});
